export function getAuctionDescription(auctionTyper: string) {
  switch (auctionTyper) {
    case 'BUY_IT_NOW': {
      return '';
    }
    case 'BUY_IT_NOW_WITH_BIDS': {
      return 'There can only be one active offer and each new offer must be higher than the last in a similar way to English auctions.';
    }
    case 'ENGLISH_AUCTION': {
      return 'During the start and end of the auction bidders will outbid each other until the bidding window closes. The auction can then be settled by anyone if there is a valid bid sending it to the winner or the seller can claim back their NFT.';
    }
    case 'DUTCH_AUCTION': {
      return 'Between the start and end of the auction the price will linearly decrease towards the reserve. The first bid above or equal to the price at the time of the auction automatically wins the auction and will receive the NFT.';
    }
    case 'BLIND': {
      return 'Blind auctions are 2 stages. Between the start and the end, users submit their hashed bids. After the end there will be a period to reveal their bid. The smart contract will record the highest bidder at the end of the reveal period (escrowing in the funds)';
    }
    default: {
      return '';
    }
  }
}
